<template>
  <div>
    <section class="page-content">
      <div class="row">
        <div class="col-md-12">
          <form action @submit.prevent="next">
            <article class="form-heading title-section-oh form-section speical-title-2-container">
              <div class="row speical-title-2-wrapper">
                <div class="col-md-4 col-sm-12 special-title-2">
                  <p class="form-title text-center" style="font-size: 15px;">
                    Product Regulation <br />
                    Property & Casualty<br />
                    50 W. Town St.<br />
                    Suite 300<br />
                    Columbus, OH 43215<br />
                    (614) 644-2635<br />
                    Fax (614) 728-1280<br />
                    www.insurance.ohio.gov<br />
                  </p>
                </div>
                <div class="col-md-4 col-sm-12 special-title-2">
                  <p class="form-title text-center" style="font-size: 20px;">
                    Ohio Department of Insurance
                    <br />

                    
                      John R. Kasich – Governor
                      <br />
                      Jillian Froment – Director

                    
                    <br />
                    Surplus Lines Statement
                  </p>
                </div>
                <div class="col-md-4 col-sm-12 special-title-2">
                  <p>
                    <section class="text-center">
                      <img src="../../../public/assets/images/oh-sl-logo.png" alt="Sign" style="max-height: 150px;" class="notice-form-date-sl-fl-text">
                    </section>

                  </p>
                </div>
              </div>
            </article>
            <article class="input-section form-section">
              <div >
                <p class="mb-3 ar-sl-disclosure">
                  
                    <b>
                      PART 1. STATEMENT OF SURPLUS LINE BROKER OR ORIGINATING AGENT
                    </b>
                  </p>
                <p class="mb-3 ar-sl-disclosure">
                  
                    Isaac Peck acknowledges that he/she is a duly licensed full multiple line agent currently licensed with
                    insurance companies, other than life, authorized to do business in Ohio or he/she is a duly licensed surplus line broker
                    pursuant to section 3905.30 of the Ohio Revised Code and that after due diligence, he/she is unable to procure the
                    insurance policy described below from insurers authorized to do business in Ohio to which he/she is a licensed agent.
                  </p>
                <p class="mb-3 ar-sl-disclosure">
                  
                    Property or risk to be insured: Home Inspector
                  </p>
                  <p class="mb-3 ar-sl-disclosure" > He/she acknowledges that he/she has complied with the applicable requirements of due diligence as set forth in
                    section 3905.33 of the Ohio Revised Code, and has explained to the insured the meaning of the signed statements
                    prior to binding coverage and received declinations for the reasons set forth below from the following authorized
                    insurer(s) to which he/she is so licensed and which are known to him/her to customarily write the kind of insurance
                    described above.</p>

                <div class="row">
                  <div class="col-md-6">
                    <section class="notice-form-date-fl">
                    <p class="mb-3 ar-sl-disclosure text-center" > INSURERS</p>
                      <p class="mb-3 ar-sl-disclosure text-center" >
                        __________________________
                      </p>
                      <p class="mb-3 ar-sl-disclosure text-center" >
                        __________________________
                      </p>
                      <p class="mb-3 ar-sl-disclosure text-center" >
                        __________________________
                      </p>
                    </section>
                  </div>
                  <div class="col-md-6">
                    <section class="notice-form-date-fl">
                      <p class="mb-3 ar-sl-disclosure text-center" > REASONS</p>
                      <p class="mb-3 ar-sl-disclosure text-center" >
                        __________________________
                      </p>
                      <p class="mb-3 ar-sl-disclosure text-center" >
                        __________________________
                      </p>
                      <p class="mb-3 ar-sl-disclosure text-center" >
                        __________________________
                      </p>
                    </section>
                  </div>
                </div>

                    <label class="notice-form-date-fl" style="margin-bottom: 20px;margin-top: 20px">Signature of Surplus Line Broker or Originating Agent: __________________________</label>

                <p class="mb-3 ar-sl-disclosure">
                  
                    <b>
                      PART 2. SIGNED STATEMENT OF INSURED AS REQUIRED BY SECTION 3905.33 OF THE OHIO
                      REVISED CODE
                    </b>
                  </p>
                <p class="mb-3 ar-sl-disclosure">
                  
                    The named insured {{ quote.fullLegalNameOfApplicant }}, acknowledges that the insurance policy (other than life insurance) as
                    described above is to be placed with an insurance company not authorized to do business in Ohio. The insured
                    understands that the insurance company is not a member of the Ohio Insurance Guaranty Association and that Chapter
                    3955 of the Ohio Revised Code is not applicable to claimants or insureds of said insurance company. The surplus line
                    broker shall collect the Ohio tax of five percent of the amount of the premium for the insurance policy at the time the
                    insurance policy is delivered to the insured.
                  </p>
                <div class="row">

                  <div class="col-md-8">
                    <section class="notice-form mt-3">
                      <p class="notice-form-date" style="text-align: left">Signature of Insured:</p>
                      <input
                        type="text"
                        class="orep-text-input notice-input"
                        placeholder="Type Your Name to Sign"
                        name="slDisclosureSignature"
                        v-validate="'required'"
                        @input="validateBeforeSubmit()"
                        v-model="quote.slDisclosureSignature"
                      >
                      <span
                        v-show="errors.has('slDisclosureSignature')"
                        class="help is-danger form-errors text-danger"
                      >{{ errors.first('slDisclosureSignature') | filterText }}</span>
                    </section>
                  </div>
                </div>
              </div>
            </article>
            <article class="input-section form-section">
              <div >
                <p class="mb-3 ar-sl-disclosure text-center" >
                  
                    <b>
                      Accredited by the National Association of Insurance Commissioners (NAIC)
                    </b>
                  </p>
                <p class="mb-3 ar-sl-disclosure">
                  
                    INS4024 (Rev. 07/2015)
                  </p>
              </div>
            </article>
          </form>
        </div>
      </div>
    </section>
    <div>
      <div class="row">
        <div class="col-md-12">
          <section class="flex wrap bottom-section">
            <router-link :to="{name:'home-inspector-7'}" class="next-btn back-btn flex mont spaced">
              <i class="fas fa-arrow-left"></i>
              Back
            </router-link>
            <article class="orep-pagination">
              <button class="pagination-dots" @click="navigateToPrev('home-inspector-1')"></button>
              <button class="pagination-dots" @click="navigateToPrev('home-inspector-2')"></button>
              <button class="pagination-dots" @click="navigateToPrev('home-inspector-3')"></button>
              <button class="pagination-dots" @click="navigateToPrev('home-inspector-4')"></button>
              <button class="pagination-dots" @click="navigateToPrev('home-inspector-5')" v-if="!state.signedInUser"></button>
              <button class="pagination-dots" @click="navigateToPrev('home-inspector-6')"></button>
              <button class="pagination-dots" @click="navigateToPrev('home-inspector-7')"               v-if="quote.applicantOrAssociateHasAnyOtherProfessionalLicense === 'true' && (checkServices('real estate agent') || checkServices('contractor') || checkServices('engineer') || checkServices('pest inspector'))"
              ></button>
              <span class="pagination-dots pagination-current"></span>
            </article>
            <button
              class="next-btn mont spaced text-uppercase"
              @click="formSubmit()"
              :disabled="!state.pageSlDisclosureIsValid"
              :class="{submitDisabled: !state.pageSlDisclosureIsValid}"
            >Submit</button>
          </section>
        </div>
      </div>
    </div>
    <div v-if="!!loading"
         class="position-fixed d-flex justify-content-center align-items-center w-100 h-100 bg-dark"
         style="opacity: 0.7; top: 0; left: 0;">
      <span class="text-white" style="font-size: 16px">Processing...</span>
    </div>

  </div>
</template>

<script>
  import $ from "jquery";
  import moment from 'moment';
  import { STATUS } from "../../utils/constants";

  export default {
    name: "home-inspector-6",
    data() {
      return {
        loading: false
      };
    },
    computed: {
      quote() {
        return this.$store.state.homeInspector.quote;
      },
      state() {
        return this.$store.state.homeInspector;
      },
      errorMsg() {
        return this.$store.state.homeInspector.errorMsg;
      }
    },
    watch: {
      errorMsg: {
        handler() {
          if (this.errorMsg) {
            this.loading = false;
            this.$notify({
              group: 'error',
              type: 'error',
              title: 'Error',
              text: this.errorMsg
            });
          }
        }
      }
    },
    methods: {
      navigateToPrev(route) {
        this.$router.push({
          name: route
        });
      },
      next(routeName) {
        this.$router.push({
          name: routeName
        });
      },
      checkServices(service) {
        return this.quote.applicantOrAssociateReportMode.includes(service);
      },
      validateBeforeSubmit() {
        this.$validator.validateAll().then(result => {
          if (result) {
            this.state.pageSlDisclosureIsValid = true;
            return;
          }
          this.state.pageSlDisclosureIsValid = false;
        });
      },

      formattedCurrentDate() {
        return moment(this.quote.applicantPrincipleEsignatureDatetime).format('YYYY-MM-DD');
      },
      formSubmit() {
        this.loading = true;
        this.quote.status = STATUS.Submitted;
        this.$store.dispatch('homeInspector/createSlDisclosure');
      }

    },


    filters: {
      filterText(x) {
        if (x !== undefined) {
          if (x.indexOf("req") !== -1) {
            return "This field is required";
          } else {
            return x.replace("_", " ");
          }
        }
      }
    },

    mounted() {
      $('html, body').animate({
        scrollTop: $('.orep-header').offset().top
      }, 500);
    },

    components: {}
  };
</script>

<style scoped>
  strong {
    text-decoration: underline;
  }
  .form-inline > label {
    width: 82px;
    text-align: left;
  }
  .form-heading > p {
    font-size: 35px;
    width: 100%;
    text-align: center;
    margin: 0;
  }
  .form-errors,
  .js-input-errors {
    display: block;
    text-transform: initial;
    font-size: 13px;
    width: 90%;
    margin: auto;
    position: relative;
    top: -29px;
  }
  fieldset {
    font-size: 12px;
  }
  .logo {
    width: 150px;
    height: 45px;
    object-fit: contain;
  }
  h6 {
    font-size: 14px;
  }
  h5 {
    font-size: 16px;
  }
  .company-info-content {
    padding: 10px 30px;
    border: 1px solid black;
  }
  .fs-subtitle {
    margin: 20px 0;
    border-bottom: 2px solid black;
  }
  table.oreptable {
    font-size: 14px;
    margin-left: auto;
    margin-right: auto;
  }
  .gen-inf {
    display: flex;
    background: #eee none repeat scroll 0 0;
    font-size: 15px;
    font-weight: 700;
    margin-bottom: 20px;
    margin-top: 20px;
    padding: 7px;
    text-align: left;
    height: 30px;
    border: 1px solid black;
  }
  .underline-value {
    margin-left: 10px;
    margin-right: 40px;
    border-bottom: 1px solid black;
    margin-bottom: 15px;
    font-weight: 700;
    font-size: 14px;
  }
  .table th, .table td {
    text-align: center;
    vertical-align: middle;
  }
  .table.ar td, .table.ar th {
    border-left: 1px solid #ddd !important;
    border-top: 1px solid #ddd !important;
    border-right: 1px solid #ddd !important;
  }
  .w-20 {
    width: 20%;
  }
  .blank_th {
    width: 210px;
  }
  .footer-company-info {
    background-color: yellow;
    border: 1px solid black;
    padding: 10px 20px 40px;
  }
  .form-check-input {
    position: relative;
    margin-left: 0;
  }
  .page-content p, .page-content li {
    font-size: 15px;
  }
  .p-56, .notice-list > li, .notice-info {
    padding-right: 56px;
  }
</style>

